var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        },
        {
          name: "drag",
          rawName: "v-drag",
          value: { handle: "#modal-moving" },
          expression: "{handle:'#modal-moving'}"
        }
      ],
      staticClass: "modal",
      staticStyle: { position: "fixed" },
      attrs: { id: "editing-modal" }
    },
    [
      _c("div", { staticClass: "modal-main" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "data-area" }, [
          _c("ul", { staticClass: "del_st" }, [
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("管理番号")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.fileObj.fdId))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("製品品番")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.fileObj.fileCode))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("編集中ユーザーID")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.fileObj.userId))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("編集中ユーザー名")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.fileObj.userName))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("編集開始日時")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.fileObj.editingDate))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.releaseFile }
            },
            [_vm._v("解除")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onCancel }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title-area", attrs: { id: "modal-moving" } },
      [_c("h2", [_vm._v("編集中ファイル強制解除")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f8cc5ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f8cc5ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/EditingModal.vue
// module id = null
// module chunks = 